// extracted by mini-css-extract-plugin
export default {"container":"SpinClock__container--QM-h1","item":"SpinClock__item--kMY0r","itemSpin":"SpinClock__itemSpin--yATX-","spin":"SpinClock__spin--OPuto"};